// @ts-nocheck
/**
 * Policy limits for ephemeral template localState (DEC-061).
 * Never persisted to SQLite / sync / backup.
 */
export const LOCAL_STATE_POLICY = {
  maxKeys: 32,
  maxKeyLength: 64,
  maxStringBytes: 4096,
  maxTotalBytes: 16384,
  keyPattern: /^[A-Za-z0-9_.-]+$/,
} as const;

export type LocalStateErrorCode =
  | 'invalid_key'
  | 'limit_keys'
  | 'limit_string'
  | 'limit_total';
